import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { IBook } from '../types'
import { Header } from '../components/header'
import { Box, Flex, Text, TextField } from '@radix-ui/themes'
import { loadBookList } from '../loaders'
import { MagnifyingGlassIcon } from '@radix-ui/react-icons'
import { useDebounce } from 'react-use'
import { BookShelf } from '../components/book-list/book-shelf'
import { AutoSizer, List } from 'react-virtualized'
import { chunks } from '../utils/arrays'
import { useForm } from 'react-hook-form'

const SEARCH_DEBOUNCE_MS = 300

const BOOK_SHELF_HEIGHT_PX = 350
const BOOK_WIDTH_PX = 240
const BOOK_SHELF_FACTOR = 0.9

export const BookListPage: React.FC = () => {

  const { register, watch } = useForm({
    defaultValues: {
      search: null
    }
  })

  const search = watch('search')

  const [books, setBooks] = useState<IBook[]>([])

  useEffect(() => {
    loadBookList().then(setBooks)
  }, [])

  useDebounce(
    () => {
      if (search === null) {
        return
      }
      loadBookList({ search }).then(setBooks)
    },
    SEARCH_DEBOUNCE_MS,
    [search]
  )

  return (
    <Wrapper direction="column">
      <Header/>
      <Box px="3" py="3">
        <form>
          <TextField.Root placeholder="Поиск" {...register('search')}>
            <TextField.Slot>
              <MagnifyingGlassIcon height="16" width="16"/>
            </TextField.Slot>
          </TextField.Root>
        </form>
      </Box>
      <Box px="3" flexGrow="1">
        {
          search && !books.length ? (
            <Text size="2">
              Ничего не найдено
            </Text>
          ) : (
            <AutoSizer>
              {
                ({ width, height }) => {
                  const booksPerShelf = Math.max(1, Math.floor(width / BOOK_WIDTH_PX * BOOK_SHELF_FACTOR))
                  const chunkedBooks = Array.from(chunks(books, booksPerShelf))

                  return (
                    <List
                      rowRenderer={
                        ({ index, style }) => <BookShelf
                          books={chunkedBooks[index]}
                          key={index}
                          style={style}
                          bookWidth={BOOK_WIDTH_PX}
                        />
                      }
                      width={width}
                      height={height}
                      rowHeight={BOOK_SHELF_HEIGHT_PX}
                      rowCount={chunkedBooks.length}
                    />
                  )
                }
              }
            </AutoSizer>
          )
        }
      </Box>

    </Wrapper>
  )
}

const Wrapper = styled(Flex)`
  height: 100vh;
`
